module.exports = __webpack_public_path__ + "static/media/jacktop-mirage.9a8cd833.webp";